import { Type } from 'class-transformer';

export class WFPaymentHistoryResultDto {
    paymentId: number;
    paymentNumber: string;
    lineAmount: number;
    paymentAmount: number;
    paymentMethod: string;
    cleared: string;

    @Type(() => Date)
    checkDate: Date;

    // Transient
    id: number;
}
